import React from 'react';
import { Link } from 'react-router-dom';
import './Notification.css';

const Notification = ({ message, linkTo, linkText, onAction, actionText, disabled }) => {
  return (
    <div className="notification-bar">
      <p className="notification-bar__message">{message}</p>
      {linkTo && linkText && (
        <Link to={linkTo} className={`notification-bar__link ${disabled ? 'disabled' : ''}`}>
          {linkText}
        </Link>
      )}
      {onAction && actionText && (
        <button 
          onClick={onAction} 
          className="notification-bar__link" 
          disabled={disabled}
          style={{ 
            background: 'none', 
            border: 'none', 
            cursor: disabled ? 'not-allowed' : 'pointer', 
            padding: 0, 
            fontSize: 'inherit', 
            fontFamily: 'inherit',
            opacity: disabled ? 0.6 : 1
          }}
        >
          {actionText}
        </button>
      )}
    </div>
  );
};

export default Notification;
